module.exports = __webpack_public_path__ + "img/keystonejs.04eab88a.svg";